import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { WarningLarge } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { setDeletingProduct } from '@yme/common/redux/cart/actions';
import { getDeletingProduct, getCartLabels } from '@yme/common/redux/cart/selectors';
import { changeItemQuantity } from '@yme/common/redux/cart/services';
import { useWindowSize } from '@yme/hooks/index';
import { setIsModalHide } from '@yme/modals/actions';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { PRODUCT_NAME_SEPARATOR } from './constants';
import { IconWrapper } from './styled';
export function ConfirmationDeletingModal() {
    const isRightToLeft = useSelector(getRTL);
    const { common_confirm_button: submitButtonLabel, common_cancel_button: cancelButtonLabel } = useSelector(getCommonLabels);
    const { sku, productName } = useSelector(getDeletingProduct);
    const { shoppingCart_confirmItemDeletePopUp_header: titleModal, shoppingCart_confirmItemDeletePopUp_message: messageModal, } = useSelector(getCartLabels);
    const dispatch = useDispatch();
    const { isInfiniteDesktopView } = useWindowSize();
    const handleHideModal = () => {
        dispatch(setIsModalHide());
        dispatch(setDeletingProduct({
            sku: '',
            productName: '',
        }));
    };
    const handleSubmitModal = () => {
        dispatch(changeItemQuantity(sku, 0));
        handleHideModal();
    };
    const modalFooter = (React.createElement(ModalWindowFooter, { isSubmitButton: true, isCancelButton: true, isSubmitButtonFullWidth: !isInfiniteDesktopView, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, onHide: handleHideModal, onSubmit: handleSubmitModal }));
    return (React.createElement(StaticModalWindow, { onHide: handleHideModal, staticModalSize: MD_MODAL, title: titleModal, minHeight: "auto", isRightToLeft: isRightToLeft, footerComponent: modalFooter },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapper, null,
                React.createElement(SVGIcon, { type: WarningLarge, size: ICON_SIZE.l }))),
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, messageModal.replace(PRODUCT_NAME_SEPARATOR, productName))));
}
